import React from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from './LoadingOverlay';
import EditableTextField from './forms/EditableTextField';
import { updateInfluencer, requestLocationChange } from '../actions';
import AvatarUploader from './AvatarUploader';
import Divider from 'material-ui/Divider';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';

import css from './viewercard.css';

// Material UI Library
import { Card, CardActions, CardText, CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import NavigationMoreHoriz from 'material-ui/svg-icons/navigation/more-horiz';
import Subheader from 'material-ui/Subheader';
import FlatButton from 'material-ui/FlatButton';

const listItemStyle = {
  padding: '8px 16px',
};

const tryMethod = (obj, methods) => methods.reduce((objAccumulator, prop) => {
  if (objAccumulator) {
    return objAccumulator[prop];
  } else if (typeof objAccumulator === 'function') {
    return objAccumulator();
  } else {
    return objAccumulator;
  }
}, obj);

class InfluencerCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = { editNotes: false, expandedAddresses: false };
  }

  editNotes = () => this.setState({ editNotes: true });

  cancelEditNotes = () => this.setState({ editNotes: false });

  updateAvatar = (image) => {
    this.handleUpdate('image', image);
  };

  handleUpdate = (key, newValue) => {
    this.props.dispatch(
      updateInfluencer(this.props.influencer.id, {
        influencer: {
          [key]: newValue,
        },
      })
    );
    this.setState({ editNotes: false });
  };

  handleToggleAddressMore = (e) => {
    e.preventDefault();
    this.setState({ expandedAddresses: !this.state.expandedAddresses });
  };

  handleEditInfluencer = (e) => {
    e.preventDefault();
    this.props.dispatch(requestLocationChange('editInfluencer', { id: this.props.influencer.id }));
  };

  handleViewCollective = (e) => {
    e.preventDefault();
    this.props.dispatch(requestLocationChange('influencerViewCollective',
      { influencerId: this.props.influencer.id, id: this.props.influencer.collectiveId }
    ));
  }

  returnAddressBlock = (address) => {
    return (
      <List key={address.id}>
        <ListItem
          primaryText={address.street1}
          secondaryText="Street Address"
          innerDivStyle={listItemStyle}
        />
        <ListItem
          primaryText={address.street2}
          secondaryText="Street Address 2"
          innerDivStyle={listItemStyle}
        />
        <ListItem
          primaryText={`${address.city}, ${address.state}`}
          secondaryText="City/State"
          innerDivStyle={listItemStyle}
        />
        <ListItem
          primaryText={`${address.zip}, ${address.country}`}
          secondaryText="Zip/Country"
          innerDivStyle={listItemStyle}
        />
      </List>
    );
  }

  render() {
    if (!this.props.influencer.gamePlatforms) return <LoadingOverlay loading={true} />;

    const { influencer } = this.props;

    return (
      <Card>
        <div>
          <div className={css.headerContainer}>
            <Avatar
              size={150}
              style={{ display: 'block', margin: 'auto' }}
              children={
                <div>
                  <AvatarUploader
                    id={influencer.id}
                    onComplete={this.updateAvatar}
                  />
                </div>
              }
              style={{
                backgroundImage: `url(${tryMethod(influencer, ['avatarUrls', 'smallSquare'])})`,
                backgroundSize: 'cover',
              }}
            />
            <div className={css.headerText}>
              <h1 style={{ margin: '16px 0 0' }}>
                {influencer.firstName} &nbsp;
                {influencer.lastName}
                {influencer.alias ?
                  `(${influencer.alias})`
                  :
                  ''
                }
              </h1>
              <p className={css.subHeader}>
                {influencer.birthdate}
                {influencer.birthdate && influencer.gender
                  ?
                  ' / '
                  :
                  ' '
                }
                {influencer.gender}
              </p>
              <p className={css.subHeader}>
                {influencer.subscriberCount || 0 } Followers
              </p>
            </div>
          </div>
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text="General Information" />
            </ToolbarGroup>
            <ToolbarGroup>
              <FlatButton onClick={this.handleEditInfluencer}>Edit</FlatButton>
            </ToolbarGroup>
          </Toolbar>
          <List>
            {this.state.editNotes
              ?
              <EditableTextField
                name="notes"
                floatingLabelText="Notes"
                type="text"
                fullWidth={true}
                value={influencer.notes}
                saveValue={this.handleUpdate.bind(this, 'notes')}
                onCancelEdit={this.cancelEditNotes}
              />
              :
              <ListItem
                onTouchTap={this.editNotes}
                primaryText={influencer.notes}
                secondaryText="Notes"
              />
            }
            <Divider />
            <ListItem
              primaryText={influencer.collectiveName}
              secondaryText="Collective"
              innerDivStyle={listItemStyle}
              onClick={this.handleViewCollective}
            />
            <Divider />
            <ListItem
              primaryText={influencer.techFocus || 'N/A'}
              secondaryText="Tech Focus"
              innerDivStyle={listItemStyle}
            />
            <Divider />
            <ListItem
              primaryText={influencer.mediaFocus || 'N/A'}
              secondaryText="Media Focus"
              innerDivStyle={listItemStyle}
            />
          </List>
          <Divider />
          <List>
            <Subheader>Platforms</Subheader>
            {influencer.gamePlatforms.map(gamePlatform =>
              <ListItem
                key={gamePlatform.id}
                primaryText={gamePlatform.name}
                innerDivStyle={listItemStyle}
              />
            )}
          </List>
          <Divider />
          <List>
            <Subheader>Interests</Subheader>
            {influencer.interests.map(interst =>
              <ListItem
                key={interst.id}
                primaryText={interst.name}
                innerDivStyle={listItemStyle}
              />
            )}
          </List>
          <Divider />
          <List>
            <Subheader>Channels</Subheader>
            {influencer.channels.map(channel =>
              <ListItem
                key={channel.id}
                primaryText={`${channel.platform}: ${channel.name} / ${channel.subscribersCount} Subscribers`}
                innerDivStyle={listItemStyle}
              />
            )}
          </List>
          <Divider />
          <List>
            <Toolbar>
              <ToolbarGroup>
                <ToolbarTitle text="Contact Information" />
              </ToolbarGroup>
            </Toolbar>
            <ListItem
              primaryText={
                influencer.emails.length ?
                influencer.emails.filter(email => email.email && email.email.length).map(email =>
                  <p key={email.id}>{email.email}</p>
                )
                :
                <span className={css.unavailable}>Unavailable</span>
              }
              secondaryText="Email"
              innerDivStyle={listItemStyle}
            />
            <Divider />
            <ListItem
              primaryText={influencer.phone || <span className={css.unavailable}>Unavailable</span>}
              secondaryText="Phone"
              innerDivStyle={listItemStyle}
            />
            <Divider />
            <ListItem
              primaryText={influencer.mobile || <span className={css.unavailable}>Unavailable</span>}
              secondaryText="Mobile"
              innerDivStyle={listItemStyle}
            />
            <Divider />
            <ListItem
              primaryText={influencer.fax || <span className={css.unavailable}>Unavailable</span>}
              secondaryText="Fax"
              innerDivStyle={listItemStyle}
            />
          </List>
          <Divider />
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text="Primary Address" />
            </ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              {this.props.influencer.addresses.length > 1 &&
                <FlatButton
                  icon={<NavigationMoreHoriz />}
                  onClick={this.handleToggleAddressMore}
                />
              }
            </ToolbarGroup>
          </Toolbar>
          {this.props.influencer.address ? this.returnAddressBlock(this.props.influencer.address) : ''}
          {this.state.expandedAddresses &&
            <div>
              <Toolbar>
                <ToolbarGroup>
                  <ToolbarTitle text="Other Addresses" />
                </ToolbarGroup>
              </Toolbar>
              {this.props.influencer.addresses.filter(address => {
                return address.street1.length && address.id !== this.props.influencer.address.id;
              }).map(address =>
                <div key={address.id}>
                  <Divider />
                  {this.returnAddressBlock(address)}
                </div>
              )}
            </div>
          }
        </div>
      </Card>
    );
  }
}

export default connect()(InfluencerCard);



/** WEBPACK FOOTER **
 ** ./components/InfluencerCard.js
 **/